import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PageView from './components/pages/PageView';
import './App.css';

function App() {
    return (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PageView />} />
            <Route path="/:slug" element={<PageView />} />
          </Routes>
        </BrowserRouter>
    );
}

export default App;
